<template lang="pug">
  .card
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalEmpleadosConDocumentos"
      )
        .card
          header.card-header
            p.card-header-title
              | ¿SEGURO QUE DESEA CONTINUAR?
          .card-content
            span {{ mensajeRespuesta }}
            .content
              ul
                li.tal(v-for="(nombre, index) in listaEmpleadosRespuesta" :key="index")
                  span {{ nombre }}
          footer.card-footer
            a.card-footer-item(
              @click="validarModalEmpleadoConDocumentos()"
            )
              span(v-if="isSaving") Guardando...
              span(v-else) Continuar
            a.card-footer-item(
              @click="cerrarModalEmpleadosConDocumentos()"
            ) Cancelar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionModal"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionModal = false"
        @do="validarConfirmacion"
        ref="confirmarEliminar"
      )
        span(slot="title") ¿Está seguro de {{ tipoConfirmacion.descripcion }}?
        span(slot="primaryAction")
          template(v-if="isSaving")
            | Guardando...
          template(v-else)
            | Guardar
    header.card-header
      p.card-header-title
        slot(name="title")
          | Seleccione los empleados
      .contenedor-acciones
        .button.is-small.is-info(@click="abrirModalConfirmacion('asignarTodos')")
          span.icon.is-small
            i.fa.fa-check
          span Asignar Todos
        .button.is-small.is-danger(@click="abrirModalConfirmacion('desasignarTodos')")
          span.icon.is-small
            i.fa.fa-times
          span Desasignar Todos

    .contenedor-interno
      transition(name="fade-quick")
        .pop-over(
            v-if="mostrarBusquedaArea"
          )
          lookup-area(
            @selected="seleccionarArea"
            @close="mostrarBusquedaArea = false"
          )
      .search
        .control
          input.input(
            type="text",
            placeholder="Buscar empleados...",
            v-model="filtro"
            @keyup.enter="selectFirst"
            @keyup.esc="close"
            ref="busqueda"
            @input="fetchSearch"
          )
        .control.pt-5(v-if="empresa !== 'raymisa'")
          .input-container
            input.input(
              type="text",
              v-model="area.idArea"
              :disabled="isLoading"
              placeholder="Buscar Area"
              readonly
              @click="mostrarBusquedaArea = true"
              v-if="!area.idArea"
            )
            .item.fdc.flex-1(v-else)
              span {{ area.nombreArea | capitalize }}
              span.name {{ area.nombreGerencia }}
            span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaArea = true")
              i.fa.fa-search
            .erase-data(@click="borrarArea")
              .icon
                .fa.fa-times
      .data
        transition-group.contenedor-data(v-infinite-scroll="fetchByScroll" infinite-scroll-disabled="disabledScrollExecute" infinite-scroll-distance="2" name="fade-smooth-two" tag="div")
          .usuario(
            v-for="(employee, index) in filteredEmpleados"
            :key="'empleado_lookup_'+employee.codigo"
            :class="{ 'selected': employee.nuevoSeleccionado || employee.seleccionado }"
            @click="toggleSelection(employee)"
          )
            .flex
              span.codigo {{ employee.dni}}:
              span.nombre &nbsp;{{ employee.nombre }}

            .mt-5(v-if="!employee.activo && employee.fechaInactivoString")
              span.name.seen.has-text-bold Inactivo desde {{employee.fechaInactivoString}}
        .info-message(v-if="!isLoading & filteredEmpleados.length === 0")
          span No se encontraron empleados activos
        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin


    footer.card-footer
      a.card-footer-item(
        @click="asignarEmpleados(false)"
      )
        span(v-if="isSaving") Guardando...
        span(v-else) Guardar
      a.card-footer-item(
        @click="close"
      ) Cancelar
</template>

<script>
import { apiDelete, apiGet, apiPost, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import Area from './lookups/Area'
import _ from 'lodash'

export default {
  name: 'employee-selector',
  props: {
    idDocumentoFirmar: Number // Se pasan como prop los empleados previamente seleccionados
  },
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent,
    'lookup-area' : Area
  },
  data () {
    return {
      filteredEmpleados                 : [],
      empleadosAuxiliar                 : [],
      filtro                            : '',
      isLoading                         : false,
      isScroll                          : false,
      isSaving                          : false,
      disabledScrollExecute             : true,
      numeroRecnum                      : 0,
      noMore                            : false,
      mostrarModalEmpleadosConDocumentos: false,
      mostrarConfirmacionModal          : false,
      mensajeRespuesta                  : '',
      listaEmpleadosRespuesta           : [],
      tipoConfirmacion                  : {},
      nombreArea                        : '',
      nombreGerencia                    : '',
      area                              :{
        idArea:'',
        idGerencia:'',
        nombreArea:'',
        nombreGerencia:''
      },
      mostrarBusquedaArea               :false,
      empresa                           : process.env.EMPRESA
    };
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  created () {
    if (this.idDocumentoFirmar) {
    }
    this.fetch();
  },
  mounted () {
    this.$refs.busqueda.focus()
  },
  methods: {
    borrarArea () {
      var vm = this
      vm.area = {}
      vm.fetch()
    },
    seleccionarArea (o) {
      var vm = this
      vm.area = o
      vm.fetch()
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetchSearch : _.debounce(function (value) {
      var vm = this
      vm.fetch()
    }, 300),
    fetch () {
      var vm = this
      vm.isLoading                = true
      vm.disabledScrollExecute   = true
      vm.noMore                   = false
      if (!vm.isScroll) {
        vm.filteredEmpleados = []
        vm.numeroRecnum = 0
      }
      var obj = {
        filtro       : vm.filtro,
        numeroRecnum : vm.numeroRecnum,
        idDocumentoFirmar: vm.idDocumentoFirmar
      }
      if (vm.area.idArea) {
        obj.area = vm.area
      }
      apiGet(vm, '/documentos-firmar/seleccionado', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          const empleado = data.lista[i]
          // Verifico en los empleados auxiliar si esta seleccionado o no (esta logica es para que este visualmente seleccionado o no)
          const empleadoAux = vm.empleadosAuxiliar.find(e => e.codigo === empleado.codigo);
          if (empleadoAux) {
            empleado.seleccionado = empleadoAux.seleccionado;
          }
          // Aqui pusheo el empleado debido al scroll infinito
          vm.filteredEmpleados.push(empleado)
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.numeroRecnum = data.numeroRecnum
          vm.disabledScrollExecute = false
        }
        vm.isLoading         = false
        vm.isScroll = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }
      , function () {
        vm.isLoading = false
        vm.isScroll = false
        vm.disabledScrollExecute = true
      })
    },
    toggleSelection (employee) {
      // Actualiza el estado seleccionado del empleado en filteredEmpleados
      employee.seleccionado = !employee.seleccionado;

      // Actualiza el estado seleccionado en empleadosAuxiliar
      const index = this.empleadosAuxiliar.findIndex(e => e.codigo === employee.codigo);
      if (index !== -1) {
        // Actualiza el estado seleccionado sin modificar otras propiedades
        this.empleadosAuxiliar[index].seleccionado = employee.seleccionado;
      } else {
        // Solo guarda el codigo y seleccionado
        this.empleadosAuxiliar.push({
          codigo: employee.codigo,
          seleccionado: employee.seleccionado,
          nombre: employee.nombre
        });
      }
    },
    close () {
      this.$emit('close');
    },
    selectFirst () {
      if (this.filteredEmpleados.length >= 1) {
        this.toggleSelection(this.filteredEmpleados[0])
      }
    },
    asignarEmpleados (eliminarForzado) {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        empleados: vm.empleadosAuxiliar,
        idDocumentoFirmar: vm.idDocumentoFirmar
      }
      if (eliminarForzado) {
        obj.eliminarForzado = true
      } else {
        obj.eliminarForzado = false
      }

      apiPost(vm, '/documentos-firmar/asignar-empleados', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message
          vm.listaEmpleadosRespuesta = data.lista
          vm.mostrarModalEmpleadosConDocumentos = true
          return
        }
        if (obj.eliminarForzado) {
          vm.cerrarModalEmpleadosConDocumentos()
        }
        vm.empleadosAuxiliar = []
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.close()
        // vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    },
    cerrarModalEmpleadosConDocumentos () {
      this.mostrarModalEmpleadosConDocumentos = false
      this.listaEmpleadosRespuesta = []
      this.tipoConfirmacion.tipo = ''
    },
    abrirModalConfirmacion (tipo) {
      this.tipoConfirmacion.tipo = tipo
      this.tipoConfirmacion.descripcion = tipo === 'asignarTodos' ? 'asignar a todos los empleados' : 'desasignar a todos los empleados'
      this.mostrarConfirmacionModal = true
    },
    validarModalEmpleadoConDocumentos () {
      if (this.tipoConfirmacion.tipo === 'desasignarTodos') {
        this.desasignarTodos(true)
      } else {
        this.asignarEmpleados(true)
      }
    },
    validarConfirmacion () {
      if (this.tipoConfirmacion.tipo === 'asignarTodos') {
        this.asignarTodos()
      } else {
        this.desasignarTodos(false)
      }
      this.mostrarConfirmacionModal = false
    },
    desasignarTodos (desasignarTodos) {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        idDocumentoFirmar: vm.idDocumentoFirmar
      }
      if (desasignarTodos) {
        obj.desasignarForzado = true
      } else {
        obj.desasignarForzado = false
      }
      if (vm.area.idArea) {
        obj.area = vm.area
      }

      apiDelete(vm, '/documentos-firmar/desasignar-todos', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message
          vm.listaEmpleadosRespuesta = data.lista
          vm.mostrarModalEmpleadosConDocumentos = true
          return
        }
        if (obj.desasignarForzado) {
          vm.cerrarModalEmpleadosConDocumentos()
        }
        vm.empleadosAuxiliar = []
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.close()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    },
    asignarTodos () {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        idDocumentoFirmar: vm.idDocumentoFirmar
      }
      if (vm.area.idArea) {
        obj.area = vm.area
      }
      apiPost(vm, '/documentos-firmar/asignar-todos', obj, function (data) {
        vm.empleadosAuxiliar = []
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.close()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.name
  font-size 12px
  color #666
.input-container
  display flex
  align-items center
  .input
    flex 1
    width 100px
  .erase-data
    cursor pointer
    margin-left 5px
.item
  background: #fff;
  border-radius: 3px;
  border: 1px solid #d6dadc;
  border-bottom-color: #c4c9cc;
  -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
  box-shadow: 0 1px 6px rgba(0,0,0,.15);
  display flex
  padding 10px
  margin-bottom 5px
  cursor pointer
  transition all .2s ease
.pop-over
  background: #fff;
  border-radius: 3px;
  border: 1px solid #d6dadc;
  border-bottom-color: #c4c9cc;
  -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
  box-shadow: 0 1px 6px rgba(0,0,0,.15);
  position: absolute;
  min-width: 100px
  width: 100%;
  z-index: 70;
  top 0
  >>> .contenedor-interno
    .data
      max-height: 365px

.content
  max-height 180px
  overflow-y auto
.employee-selector
  width 200px
  background-color #f0f4f8
  border-radius 8px
  padding 10px


ul
  list-style none
  padding 0
  margin 0


.selected
  background-color #97c3d7 !important /* Estilo para los seleccionados previamente */


.new-selected
  background-color #61aed1 !important /* Estilo para los nuevos seleccionados */

.color-white
  color #fff



button
  margin-top 10px
  padding 8px 12px
  background-color #007bff
  color white
  border none
  border-radius 4px
  cursor pointer
  transition background-color 0.3s
.contenedor-acciones
  padding 0.75rem
  .button
    margin 5px

button:hover
  background-color #0056b3
.search
  padding 5px 10px
.data
  max-height 250px
  overflow-y auto
  .contenedor-box
    >*
      transition all .5s
      width 100%
  padding 10px
  .usuario
    background #fff
    border-radius 3px
    border 1px solid #d6dadc
    border-bottom-color #c4c9cc
    -webkit-box-shadow 0 1px 6px rgba(0,0,0,.15)
    box-shadow 0 1px 6px rgba(0,0,0,.15)
    padding 10px
    margin-bottom 5px
    cursor pointer
    transition all .2s ease
    width 100%
    &:hover
      background-color #edeff0
      margin-left 4px
      -webkit-box-shadow -8px 0 #959da17d
      box-shadow -8px 0 #959da17d

    .nombre
      flex 1
</style>



// WEBPACK FOOTER //
// Component_Seleccionar_Empleado.vue?3af883c0